import { Box, Pagination } from "@mui/material";
import { SOCIAL_LIST_PAGE_SIZE } from "Pages/People/constants";

type Props = {
  totalCount: number;
  currentPage: number;
  onPageChange: (page: number) => void;
};

/** Pagination footer of a social list; hidden while everything fits one page. */
export const SocialListPagination = ({
  totalCount,
  currentPage,
  onPageChange,
}: Props) => {
  const totalPages = Math.ceil(totalCount / SOCIAL_LIST_PAGE_SIZE);

  if (totalPages <= 1) {
    return null;
  }

  return (
    <Box display="flex" justifyContent="center" mt={1}>
      <Pagination
        count={totalPages}
        page={currentPage}
        onChange={(_, page) => onPageChange(page)}
        color="primary"
      />
    </Box>
  );
};
